import React from "react";
import {
  getWindowDimensions,
  hideAuthAlert,
  sendVerificationCode,
} from "../../../actions/actionCreators";
import Grid from "@material-ui/core/Grid";
import nobaarLogo from "../Header/logo.svg";
import loginImg from "./login.svg";
import codeImg from "./code.svg";
import { connect } from "react-redux";
import { compose } from "redux";
import withStyles from "@material-ui/core/styles/withStyles";
import { DISABLE_SHOULD_LOGIN } from "../../../actions/actionsTypes";
import AuthInput from "./AuthInput";
import AuthInput2 from "./AuthInput-V2";
import { store } from "../../../store";
import { push } from "connected-react-router";
import ExtractUtmSource from "./UTM/ExtractUtmSource";
import InfoSlider from "./InfoSlider/index";
import { Box } from "@material-ui/core";

/**
 * JSS
 * @param theme
 * @return {{input: {"& input": {"&[type=number]": {"-moz-appearance": string, "-webkit-appearance": string}, "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {"-moz-appearance": string, margin: number, "-webkit-appearance": string}}}, root: {padding: string, backgroundColor: (string|string), position: string, zIndex: number}, box: {margin: string, "& > *": {margin: string}, maxWidth: number}}}
 */
const styles = (theme) => ({
  root: {
    padding: "20px",
    position: "fixed",
    width: "100%",
    height: "100%",
    overflow: "auto",
    zIndex: 99999999999,
    backgroundColor: theme.palette.primary.light,
  },
  box: {
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    maxWidth: 600,
    margin: "0 auto",
    "& > *": {
      margin: ".3rem 0",
      // [theme.breakpoints.down("xs")] : {
      //     margin: ".2rem 0",
      // }
    },
  },
  img: {
    width: 150,
  },
  logoContainer: {
    marginBottom: 32,
    marginTop: 24,
    cursor: "pointer",
  },
});

const mapStateToProps = (state) => ({ ...state });

const mapDispatchToProps = (dispatch) => ({
  disableShouldLogin: (e) => {
    dispatch({ type: DISABLE_SHOULD_LOGIN });
  },
});
class Authentication extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentCount: 60,
    };
  }

  /**
   * Send Authentication Code to the entered Phone.
   */
  sendCode = () => {
    const {
      state: { interval },
    } = this;
    clearInterval(interval);
    this.setState({
      alertValidation: false,
      currentCount: 60,
      interval: setInterval(this.timer, 1000),
    });
    sendVerificationCode();
  };

  /**
   * Goes in the interval.
   */
  timer = () => {
    if (this.state.currentCount < 1) clearInterval(this.state.interval);
    this.setState({ currentCount: this.state.currentCount - 1 });
  };

  /**
   * Triggers when closing auth page
   */
  closeAuth = () => {
    if (this.props.auth.shouldLogin) store.dispatch(push("/"));
    hideAuthAlert();
    this.props.disableShouldLogin();
  };

  render() {
    const {
      state: { currentCount },
      props: {
        classes,
        auth: { authenticated, verifyAlert, authentication },
      },
      closeAuth,
      sendCode,
    } = this;

    const { height, width } = getWindowDimensions();

    if (authentication)
      return (
        <form onSubmit={(e) => e.preventDefault()}>
          <Box className={classes.root}>
            <Box
              className={classes.box}
              container
              alignItems={"center"}
              direction={"column"}
            >
              <Grid
                onClick={() => {
                  window.location.href = "https://nobaar.com";
                }}
                item
                className={classes.logoContainer}
              >
                <a href="https://nobaar.com">
                  <img className={classes.img} src={nobaarLogo} alt={"logo"} />
                </a>
              </Grid>
              <AuthInput counter={currentCount} sendCode={sendCode} />
              {/* <AuthInput2 counter={currentCount} sendCode={sendCode} /> */}
              <Box item container justifyContent="center">
                {verifyAlert ? (
                  <img src={codeImg} alt={"login"} />
                ) : (
                  <InfoSlider />
                  // <img src={loginImg} alt={'login'}/>
                )}
              </Box>
            </Box>
          </Box>
        </form>
      );

    return null;
  }
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(styles),
  ExtractUtmSource
)(Authentication);
